export default __webpack_public_path__ + "static/media/briefcase.61b8ce0c.svg";